import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './AdminNav.css';
import { useUser } from '../../context/UserContext';

const AdminNav = () => {
  const { user, setUser } = useUser();
  const isActivated = !!(user && user.is_activated);
  const isAdmin = !!(user && user.is_admin);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/admin/login');
  };

  return (
    <nav className="admin-nav">
      <ul>
        <li>
          <NavLink to="/admin/mainpage" activeClassName="active">Főoldal</NavLink>
        </li>
        {isActivated && (
          <>
            <li>
              <NavLink to="/admin/postcontrol" activeClassName="active">Bejegyzések kezelése</NavLink>
            </li>
            {isAdmin && (
              <li>
                <NavLink to="/admin/usercontrol" activeClassName="active">Felhasználók kezelése</NavLink>
              </li>
            )}
            <li>
              <NavLink to="/admin/upload" activeClassName="active">Új bejegyzés feltöltése</NavLink>
            </li>
          </>
        )}
        {user && (
          <li>
            <button className="logout-btn" onClick={handleLogout}>Kijelentkezés</button>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default AdminNav;
